import useAxios from '../../../library/axios'; 

import IProduct from '../model/Product';
import IBankPolicy from '../../crm/model/BankPolicy';

const _ = () => {

    const axios = useAxios();

    const getProduct = async (productCode: string) : Promise<IProduct>  => {
        //console.log('000 => ' + productCode);
        const {data} = (await axios.get(`/product/product/getProduct/${productCode}`));
        return await data;
      }

    const getDefaultBankPolicy = async (groupPolicyID: number,productCode: string) : Promise<IBankPolicy>  => {
        //console.log('000 => ' + productCode);
        const {data} = (await axios.get(`/product/product/getDefaultBankPolicy/?groupPolicyID=${groupPolicyID}&productCode=${productCode}`));
        return await data;
      }
    
    return {
        getProduct,
        getDefaultBankPolicy
      
    } 
}

export default _;